import { graphql } from '@/graphql'

export const GET_FILE_DOWNLOAD_URL_MUTATION = graphql(`
  mutation GetFileDownloadUrl($fileId: String!, $derivative: String) {
    getFileDownloadUrl(fileId: $fileId, derivative: $derivative) {
      downloadUrl
      fileId
      derivative
      filename
      mimeType
      size
      expiresAt
    }
  }
`)

export type FileDownloadUrlResponse = {
  downloadUrl: string
  fileId: string
  derivative: string
  filename: string
  mimeType: string
  size: number
  expiresAt: string
}

export type GetFileDownloadUrlVariables = {
  fileId: string
  derivative?: 'original' | 'thumbnail' | 'pdf-optimized' | 'watermarked'
}
